declare const __APP_ENV__: string | undefined;
declare const __APP_IS_WIDGET__: boolean | undefined;
declare const __APP_PUBLIC_URL__: string | undefined;
declare const __APP_CONFIG__: Record<string, unknown> | undefined;

interface IRuntimeScope {
    __APP_ENV__?: string;
    __APP_IS_WIDGET__?: boolean;
    __APP_PUBLIC_URL__?: string;
}

const runtimeScope: IRuntimeScope = typeof window !== 'undefined' ? (window as IRuntimeScope) : {};

const getNodeEnv = () => {
    if (typeof __APP_ENV__ === 'string') {
        return __APP_ENV__;
    }

    if (typeof runtimeScope.__APP_ENV__ === 'string') {
        return runtimeScope.__APP_ENV__;
    }

    return 'development';
};

const isWidgetMode = () => {
    if (typeof __APP_IS_WIDGET__ === 'boolean') {
        return __APP_IS_WIDGET__;
    }

    if (typeof runtimeScope.__APP_IS_WIDGET__ === 'boolean') {
        return runtimeScope.__APP_IS_WIDGET__;
    }

    return false;
};

const getPublicUrl = () => {
    if (typeof __APP_PUBLIC_URL__ === 'string') {
        return __APP_PUBLIC_URL__;
    }

    if (typeof runtimeScope.__APP_PUBLIC_URL__ === 'string') {
        return runtimeScope.__APP_PUBLIC_URL__;
    }

    return '';
};

const getEmbeddedConfig = () => {
    if (typeof __APP_CONFIG__ !== 'undefined') {
        return __APP_CONFIG__;
    }

    if (typeof window !== 'undefined' && window.__APP_CONFIG__ !== undefined) {
        return window.__APP_CONFIG__;
    }

    return null;
};

export { getNodeEnv, getPublicUrl, isWidgetMode, getEmbeddedConfig };
